import React, {useState, useEffect}from 'react';
import NavbarComponent from '../../Navbar/index';
import RenovateTokenAlert from '../../../RenovateToken';
import Backend from '../../../Backend';
import Connection from '../../../Calls';
import ApiRow from '../../Settings/apiRow'

import PersonaInformation from './Components/PersonalInformation';
import BankInformation from './Components/BankInformation'
import Services from './Components/Services'
import PlanInfo from './Components/Plan';

import './index.css'

const Settings = (props) => {
    const [Tab, setTab] = useState( (props.data.location.state)?props.data.location.state.Tab:'Personal')
    const [ClientInfo, setClientInfo] = useState({})
    const [BankList, setBankList] = useState({})
    const [ClientInfo2, setClientInfo2] = useState({})
    const [Api_keys, setApi_keys] = useState([])
    const [Group_info, setGroup_info] = useState({})
    const [TwoFa, setTwoFa] = useState({
        status:'',
        qr_code:''
    });
    const [Plan, setPlan] = useState({})

    useEffect(() => {
        GetInformation()
    }, [])
    // ------------ CALLS ------------
    const GetInformation = () => {
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";

        navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
        });

        result = latitude + longitude;

        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            var payload = response.payload
            Backend.get_client_data(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
                if(response.status.code == '0'){
                    setClientInfo(response.payload.client_info)
                }
            });
            Backend.client_banks_list(localStorage.getItem('email'), localStorage.getItem('token'), 'all',response.payload.r01, response => {
                if(response.status.code == '0'){
                    setBankList(response.payload.list_banks)
                }
            });
            Backend.GetUserInfo(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01, response => {
                if(response.status.code == 0){
                    setClientInfo2(response.payload.client_info)
                }
            });
            Backend.GetUserInfo2(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01, response => {
                if(response.status.code == 0){
                    setGroup_info(response.payload)
                }
            });
            Backend.GetAPIKeys(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01, response => {
                if(response.status.code == 0){
                    setApi_keys(response.payload)
                }
            });
            Backend.GroupInformationPlanInfo(localStorage.getItem('email'), localStorage.getItem('token'), payload.r01, response => {
                if (response.status.code === "0") {
                    setPlan(response.payload.plan)
                }
            });
        });
        GetTwoFa()
    }

    const GetBankList = () => {
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";

        navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
        });

        result = latitude + longitude;

        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            Backend.client_banks_list(localStorage.getItem('email'), localStorage.getItem('token'), 'all',response.payload.r01, response => {
                if(response.status.code == '0'){
                    setBankList(response.payload.list_banks)
                }
            });
        });
    }

    const GetGroupInfo = () => {
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";

        navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
        });

        result = latitude + longitude;

        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            Backend.GetUserInfo2(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {

                if(response.status.code == 0){
                    setGroup_info(response.payload)
                }
            });
        });
    }

    const GetTwoFa = () => {
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";
        navigator.geolocation.getCurrentPosition((success, error, options) => {
          latitude = success.coords.latitude;
          longitude = success.coords.longitude
        });

        result = latitude + longitude;

        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            Backend.Get2FA(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
                if(response.status.code == 0){
                    setTwoFa({
                        status:response.payload.status,
                        qr_code:response.payload.qr_code
                    })
                }
              });
        })
    }

    const GetApiKeys = () => {
        let date = new Date(), confirmation = Connection.Uwx6GVhZ(), result = "", combination = Connection.RThzHrsb("XCHF101"), latitude = "0", longitude = "0";

        navigator.geolocation.getCurrentPosition((success, error, options) => {
        latitude = success.coords.latitude;
        longitude = success.coords.longitude
        });

        result = latitude + longitude;

        Connection.EZcga8qH(confirmation, date, result, "XL7FefG", combination, "XCHF101", response => {
            Backend.GetAPIKeys(localStorage.getItem('email'), localStorage.getItem('token'), response.payload.r01, response => {
                if(response.status.code == 0){
                    setApi_keys(response.payload)
                }
            });
        });
    }

    // ------------ RENDERS ------------

    const renderApiKey = () => {
        return(
            <>
                <p className='title-container-shadow' style={{marginBottom:16}}>Api Keys</p>
                <table className="table-container-wallets-generals">
                    <thead>
                        <tr>
                            <th className="header-table-wallets-generals fixxxed">API Key</th>
                            <th className="header-table-wallets-generals fixxxed">Status</th>
                            <th className="header-table-wallets-generals fixxxed">Last Use</th>
                            <th className="header-table-wallets-generals fixxxed">API Secret</th>
                            <th className="header-table-wallets-generals fixxxed">API Totp</th>
                            <th className="header-table-wallets-generals fixxxed"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderTable()}
                    </tbody>
                </table>
            </>
        )
    }
    const renderTable = () => {

        return Api_keys.map(item=>{
            return(
                <ApiRow getAPIKeys={GetInformation} {...item}/>
                // <tr>
                //     <td className='text-table-container-addres-information'>{item.apiKey}</td>
                //     <td className={'text-table-container-addres-information ' + item.status}>{item.status}</td>
                //     <td className='text-table-container-addres-information'>{item.last_use}</td>
                //     <td className='text-table-container-addres-information'>{item.apiSecret}</td>
                //     <td className='text-table-container-addres-information'>{item.apiTotp}</td>
                // </tr>
            )
        })

    }
    const renderMore = () => {
        let data ={
            TransfersAlias:Group_info.group_nick,
            twofa:TwoFa,
            whitelist_status:Group_info.whitelist_active,
            ApiStatus:Group_info.api_status
        }
        return(
            <>
                <Services data={data} Api_keys={Api_keys} GetGroupInfo={GetGroupInfo} GetTwoFa={GetTwoFa} GetApiKeys={GetApiKeys} history={props.data.history} type={ClientInfo.type} pending_upgrade={ClientInfo.pending_upgrade} traductions={props.traductions}/>
            </>
        )
    }

    return (
        <div>
            <NavbarComponent data={props} selected="invoice" logged={true} />
            <RenovateTokenAlert data={props} />

            <div className='ContenedorSettings'>
                <div style={{display:'flex'}}>
                    <div md='auto' className='sideBar'>
                        <div onClick={()=>setTab('Personal')} className={(Tab=='Personal')?'active':''}>{props.traductions.settings.tab_Personal}</div>
                        <div onClick={()=>setTab('Bank')} className={(Tab=='Bank')?'active':''}>{props.traductions.settings.tab_Bank}</div>
                        {/* <div onClick={()=>setTab('Plan')} className={(Tab=='Plan')?'active':''}>Plan</div> */}
                        {/* <div onClick={()=>setTab('ApiKey')} className={(Tab=='ApiKey')?'active':''}>Api Keys</div> */}
                        <div onClick={()=>setTab('Services')} className={(Tab=='Services')?'active':''}>{props.traductions.settings.tab_Services}</div>


                    </div>
                    <div className='contenido'>
                        {
                            (Tab=='Personal')
                            ?  <PersonaInformation ClientInfo2={ClientInfo2} Group_info={Group_info} ClientInfo={ClientInfo} history={props.data.history} traductions={props.traductions}/>
                            :   (Tab=='Bank')
                                    ?   <BankInformation BankList={BankList} getBankList={GetBankList} history={props.data.history} type={ClientInfo.type} pending_upgrade={ClientInfo.pending_upgrade} traductions={props.traductions}/>
                                    :   (Tab=='ApiKey')
                                            ?   renderApiKey()
                                            :   (Tab=='Services')
                                                ?  renderMore()
                                                :   (Tab=='Plan')
                                                    && <PlanInfo info={Plan} traductions={props.traductions}/>
                        }
                    </div>
                </div>
            </div>
        </div>
     );
}

export default Settings;
